<template>
    <select :id="id" :name="name" class="form-control form-control--select" :class="className" :tabindex="tabindex" @change="onChangeItem">
        <template v-if="hasPlaceholder">
            <option value="0">{{ placeholder }}</option>
        </template>
        <template v-for="item in items">
            <option :value="item.id" :selected="isSelectedItem(item.id)">{{ item.title }}</option>
        </template>
    </select>
</template>

<script>
    export default {
        props : {
            id : {
                type : String,
                default : ''
            },
            name : {
                type : String,
                required : true
            },
            value : {
                type : [String, Number],
                default : ''
            },
            placeholder : {
                type : String,
                default : ''
            },
            className : {
                type : String,
                default : ''
            },
            tabindex : {
                type : [String, Number],
                default : ''
            }
        },
        data() {
            return {
                items   : this.getItems()
            };
        },
        computed : {
            hasPlaceholder : function () {
                return this.placeholder !== '';
            }
        },
        methods : {
            getItems : function () {
                var placementTypes = [];

                this.$helpers.placementTypes.forEach((function (placementType, index) {
                    placementTypes.push({
                        id      : index + 1,
                        title   : this.$t('placementtype.' + (parseInt(index) + 1)),
                        type    : placementType
                    });
                }).bind(this));

                return placementTypes;
            },
            onSelectItem : function (id) {
                this.$emit('input', id);
                this.$emit('change', this.getItemById(id));
            },
            onChangeItem : function (event) {
                this.onSelectItem(parseInt(event.currentTarget.value));
            },
            isSelectedItem : function (id) {
                return this.value === id;
            },
            getItemById : function (id) {
                var output = null;

                this.items.forEach((function (item) {
                    if (item.id === id) {
                        output = item;
                    }
                }).bind(this));

                return output;
            }
        }
    }
</script>